import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0E3A5F] mb-4">
            Success Stories
          </h2>
          <p className="text-xl text-gray-600">
            Real businesses that made the switch from SaaS to ownership
          </p>
        </div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#7AC943] relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 opacity-10">
                <Quote className="h-16 w-16 text-[#1F6FB2]" />
              </div>

              {/* Quote */}
              <div className="relative mb-6">
                <p className="text-gray-700 leading-relaxed italic">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Attribution */}
              <div className="border-t-2 border-gray-100 pt-4">
                <div className="flex items-center gap-3">
                  {/* Avatar Circle */}
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#1F6FB2] to-[#7AC943] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-lg">
                      {testimonial.firstName.charAt(0)}
                    </span>
                  </div>
                  
                  {/* Details */}
                  <div>
                    <div className="font-bold text-[#0E3A5F]">
                      {testimonial.firstName}
                    </div>
                    <div className="text-sm text-gray-600">
                      {testimonial.industry}
                    </div>
                  </div>
                </div>

                {/* System Replaced Badge */}
                <div className="mt-4 inline-block">
                  <div className="bg-[#7AC943]/10 border border-[#7AC943]/30 rounded-lg px-3 py-1.5">
                    <div className="text-xs text-gray-500 mb-0.5">Replaced:</div>
                    <div className="text-sm font-semibold text-[#1F6FB2]">
                      {testimonial.systemReplaced}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
